export const MY_WORK_PATH = "/tasks/my-work";
